<template>
  <div class="loginForm">
    <div style="width: 100%;height: 40px;background-color: #2d2d2d;">
      <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;">
        忘记密码
      </span>
      <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: right;margin-right: 20px;">
        <a href="javascript:;" @click="close">
          <i class="el-icon-close"></i>
        </a>
      </span>
    </div>
    <div style="width: 300px;margin: 0 auto;">
      <!--登录input框-->
      <!--普通登录input框-->
      <div id="ptemailupdate">
        <el-form :model="updateEmailForm" style="margin-top: 40px;">
          <el-form-item prop="username">
            <el-input type="text" v-model="updateEmailForm.email" placeholder="邮箱号">
              <template slot="prepend"><i class="el-icon-message" style="font-size: 20px; color: #000000;"></i></template>
            </el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-input type="text" v-model="updateEmailForm.codes" placeholder="验证码" @keyup.enter.native="clickLogin">
              <template slot="prepend"><i class="el-icon-postcard" style="font-size: 20px;color: #000000;"></i></template>
              <a href="javascript:;" slot="append" @click="getlogincode">
                <img :src="logincode.img" alt=" " style="width: 80px;height: 33px;" >
              </a>
            </el-input>
          </el-form-item>
          <el-form-item prop="phonecode">
            <el-input type="text" v-model="updateEmailForm.code" placeholder="邮箱验证码">
              <template slot="prepend"><i class="el-icon-postcard" style="font-size: 20px;color: #000000;"></i></template>
              <el-button slot="append" size="mini" @click="updatapassEmailCode" :disabled="button_tof">{{content}}</el-button>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="loading" style="width: 300px;" @click="email_update_pass">下一步</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!--密码修改-->
      <div id="ptpasswordupdate" style="display: none;">
        <el-form :model="updateEmailForm" style="margin-top: 40px;">
          <el-form-item prop="username">
            <el-input type="text" v-model="updateEmailForm.password" placeholder="新密码" show-password>
              <template slot="prepend"><i class="el-icon-lock" style="font-size: 20px; color: #000000;"></i></template>
            </el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-input type="text" v-model="updateEmailForm.repassword" placeholder="确认新密码" show-password>
              <template slot="prepend"><i class="el-icon-lock" style="font-size: 20px;color: #000000;"></i></template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="loading" style="width: 300px;" @click="sendupdatePassword">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div style="width: 300px;overflow: hidden;margin: 0 auto;margin-bottom: 20px;">
      <span style="font-size: 14px;color: #c6c6c6;">————— 只支持邮箱找回 —————</span>
    </div>
    <div style="height: 50px;background-color: #f7f7f7;">
      <span style="float: left;margin-left: 20px;line-height: 50px;font-size: 14px;">
        <a href="javascript:;" style="color: #415bec;" @click="closePasswordMain()">返回登录</a>
      </span>
    </div>
  </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
  import {codeAPI} from '@/api/codeAPI'
export default {
  data () {
    return {
      //用户密码前端salt
      usersalt:'havetorich',
      //用户相关信息
      UserInfor:{
        photo:'',
        name:'',
        id:'',
        token:'',
      },
      loading: false,   //登陆加载效果
      //页面定位
      activeIndex: this.$route.path,
      //登录信息
      loginForm: {
        username: '',
        password: '',
        code:''
      },
      //邮箱修改
      updateEmailForm: {
        email: '',
        codes:'',
        code:'',
        emailinput:false,
        password:'',
        repassword:'',
        CodeType:1,//0代表初始值,1代表直接输入电话或者邮箱，2代表用户获取
        GetType:2,//进行分类分解。int型，0代表初始值,1代表电话，2代表邮箱
      },
      //计时器
      content: '获取',
      totalTime: 60,
      canClick: true ,//添加canClick
      button_tof:false,
      //手机短信计时器
      phonecontent: '获取',
      phonetotalTime: 60,
      phonecanClick: true ,//添加canClick
      phonebutton_tof:false,
      //传回来的验证码
      getemailcode:'',
      getemail:'',
      //登录验证码
      logincode:{
        logincode:'',
        img:''
      },
    }
  },
  //页面开启时执行
  mounted(){
    this.getlogincode();
  },
  //方法
  methods: {
    //提交修改
    sendupdatePassword(){
      if(this.updateEmailForm.password.length<=0){
        this.$message({
          message: '请填写新密码',
          type: 'error'
        });
        return false;
      }
      if(this.updateEmailForm.password.length<6||this.updateEmailForm.password.length>16){
        this.$message({
          message: '密码长度在6-16位',
          type: 'error'
        });
        return false;
      }
      if(this.updateEmailForm.password!=this.updateEmailForm.repassword){
        this.$message({
          message: '两次密码不一致',
          type: 'error'
        });
        return false;
      }
      let pass=this.updateEmailForm.password;
      this.updateEmailForm.password=this.$md5(this.updateEmailForm.password+this.usersalt);
      this.updateEmailForm.repassword=this.$md5(this.updateEmailForm.repassword+this.usersalt);
      //进行密码的修改
      this.loading=true;
      commonAPI('updatePassword', this.updateEmailForm).then(res => {
      let data = res.data;
      if(this.response.response(data)){
        this.updateEmailForm.password="";
        this.updateEmailForm.repassword="";
        this.updateEmailForm.email="";
        this.updateEmailForm.code="";
        this.updateEmailForm.codes="";
        this.loading=false;
        document.getElementById('ptemailupdate').style.display='block';
        document.getElementById('ptpasswordupdate').style.display='none';
        //this.relogin()
      }else{
        this.updateEmailForm.password=pass;
        this.updateEmailForm.repassword=pass;
        this.loading=false;
      }
      }).catch(error=>{
        //this.loading = false;
        this.$notify({//这里采用element ui的一个错误显示效果模板
        title: '提示',
        message: error.message,
        position: 'bottom-right',
        type: 'error'
      });
      })
    },
    //打开修改密码界面
    openUpdatePassword(){
      document.getElementById('ptemailupdate').style.display='none';
      document.getElementById('ptpasswordupdate').style.display='block';
    },
    //判定邮箱验证码是否正确对应
    email_update_pass(){
      let emailPD=/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if(this.updateEmailForm.email.length<=0){
        this.$message({
          message: '请输入邮箱号码',
          type: 'error'
        });
        return false;
      }
      if(!emailPD.test(this.updateEmailForm.email)){
        this.$message({
          message: '邮箱格式不正确',
          type: 'error'
        });
        return false;
      }
      if(this.updateEmailForm.code.length<=0){
        this.$message({
          message: '请输入邮箱验证码',
          type: 'error'
        });
        return false;
      }
      this.updateEmailForm.code=this.updateEmailForm.code.toLocaleLowerCase();
      this.loading=true;
      //封装的公共请求API
      commonAPI('queryPDEmailCode', this.updateEmailForm).then(res => {
      let data = res.data;
      if(this.response.response(data)){
        this.loading=false;
        this.openUpdatePassword()
      }else{
        this.loading=false;
      }
      }).catch(error=>{
        //this.loading = false;
        this.$notify({//这里采用element ui的一个错误显示效果模板
        title: '提示',
        message: error.message,
        position: 'bottom-right',
        type: 'error'
      });
      })
    },
    close(){
      this.updateEmailForm.email="";
      this.updateEmailForm.code="";
      this.updateEmailForm.codes="";
      document.getElementById('ptlogin1').style.display='block';
      document.getElementById('other').style.display='none';
      document.getElementById('ptlogin').style.display='block';
      document.getElementById('phonelogin').style.display='none';
      document.getElementById('loginmain').style.display='none';
      document.getElementById('zhedang').style.display='none';
      document.getElementById('registermain').style.display='none';
      document.getElementById('passwordMain').style.display='none';
    },
    //修改密码邮箱验证码
    updatapassEmailCode(){
      let emailPD=/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if(this.updateEmailForm.email.length<=0){
        this.$message({
          message: '请输入邮箱号码',
          type: 'error'
        });
        return false;
      }
      if(!emailPD.test(this.updateEmailForm.email)){
        this.$message({
          message: '邮箱格式不正确',
          type: 'error'
        });
        return false;
      }
      if(this.updateEmailForm.codes.length<=0){
        this.$message({
          message: '请输入验证码',
          type: 'error'
        });
        return false;
      }
      //判定验证码是否正确
      let codes=this.updateEmailForm.codes;
      let PD = eval(/^\d+$/);
      let codePD=this.logincode.logincode;
      if(PD.test(codePD)){
        if (codes.length === 0) {
          this.$message({
            message: '请输入验证码',
            type: 'error'
          });
          return false;
        } else if(codePD*1!==codes*1){
          this.$message({
            message: '验证码错误',
            type: 'error'
          });
          this.getlogincode();
          return false;
        }
      }else{
        if (codes.length === 0) {
          this.$message({
            message: '请输入验证码',
            type: 'error'
          });
          return false;
        } else if(codePD.toUpperCase()!==codes.toUpperCase()){
          this.$message({
            message: '验证码错误',
            type: 'error'
          });
          this.getlogincode();
          return false;
        }
      }
      this.countDown();
      commonAPI('GetP_ECode', this.updateEmailForm).then(res => {
  	this.getlogincode();
        let data=res.data
        if(this.response.response_code(data)){}
      })
    },
    //打开关闭忘记密码
    openPasswordMain(){
      document.getElementById('loginmain').style.display='none';
      document.getElementById('passwordMain').style.display='block';
    },
    closePasswordMain(){
      this.updateEmailForm.email="";
      this.updateEmailForm.code="";
      this.updateEmailForm.codes="";
      document.getElementById('loginmain').style.display='block';
      document.getElementById('passwordMain').style.display='none';
    },
    //获取登录验证码方法
    getlogincode(){
      commonAPI('getLoginCodes', this.logincode).then(res => {
        let data=res.data
        this.logincode.logincode=data
        codeAPI('getLoginCode', this.logincode).then(res => {
          let url = window.URL.createObjectURL(res.data);
          this.logincode.img=url
          //console.log(url)
        })
      })
    },
    //找回密码——跳转新页面
    openrepass(){
      let i=1;
    },
    //倒计时
    countDown () {
     if (!this.canClick) return  //改动的是这两行代码
     this.button_tof = true
     this.canClick = false
     this.content = this.totalTime
     let clock = window.setInterval(() => {
      this.totalTime--
      this.content = this.totalTime
      if (this.totalTime <= 0) {
       window.clearInterval(clock)
       this.content = '获取'
       this.totalTime = 60
       this.canClick = true  //这里重新开启
       this.button_tof = false
       this.updateEmailForm.emailinput = false;
      }
     },1000)
    },

  }
}
</script>

<style scoped>
  /**登录框架*/
  .logindiv{
    position: fixed;
    top: 20%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:2002;
    overflow: auto;
    text-align: center;
    display: none;
  }
  .loginForm{
    margin: 0 auto;
    width: 550px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .loginForm a{
    color: #fff;
  }
  .loginForm a:hover{
    color: #d6d6d6;
  }

  .playlistbox_botton{
     width: 305px;
  	  margin: 0 auto;
  	  overflow: hidden;
  	  max-height: 300px;
     overflow-y: scroll;
   }
</style>



// WEBPACK FOOTER //
// src/components/LoginPage/loginpage_repassword.vue